var TabTypes = {
  NORMAL: 'normal',
  SUBTABS: 'subtabs'
};
var getTabTypes = function getTabTypes() {
  return Object.keys(TabTypes).map(function (key) {
    return TabTypes[key];
  });
};

export { TabTypes, getTabTypes };
//# sourceMappingURL=TabTypes.js.map
